"use client";

import { useState,useEffect,useRef } from 'react';
import Header from "./header"; // Import your server component
import * as All from '@/element/common/elmntbase';
import { useMotionValue, useSpring, animate } from "framer-motion";


export default function HeaderWrapper({children}: any) {
    const [open, setOpen] =  useState (false);
    const [isDesktop,setIsDesktop] = useState(true);
    const [height, setHeight] = useState(0);
    const containerRef = useRef<HTMLDivElement | null>(null);
    const y = useMotionValue(0); // animated Y position
    const scrollRef = useRef(0); // current scrollY

    useEffect(()=>{
        const handleResize = () =>{
            if (window.innerWidth >= 991){
                setIsDesktop(true);
            }
            else{
                setIsDesktop(false);
            }
        }        
        handleResize();       
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize); 
    },[]);
    
    // Track scroll position and animate the transform
    useEffect(() => {
        if (!isDesktop) return;

        const updateHeight = () => {
            if (containerRef.current) {
            const newHeight = containerRef.current.getBoundingClientRect().height;
            setHeight(newHeight);
            }
        };

        // Call initially
        updateHeight();

        const update = () => {
        scrollRef.current = window.scrollY;
        };

        const loop = () => {
        animate(y, -scrollRef.current, {
            type: "spring",
            damping: 35,
            stiffness: 120,
            mass: 0.4,
        });
        // request the next frame
        requestAnimationFrame(loop);
        };

         // ResizeObserver to track container height
        let observer: ResizeObserver | null = null;

        if (containerRef.current) {
        observer = new ResizeObserver((entries) => {
            // for (const entry of entries) {
            //     if (containerRef.current) {
            //         const scrollHeight = entry.target.getBoundingClientRect().height;
            //         // const scrollHeight = entry.target.getBoundingClientRect().height;
            //         setHeight(scrollHeight);
            //     }
            // }
            updateHeight();
        });
         if (containerRef.current) {
            observer.observe(containerRef.current);
        }    
        setTimeout(() => {
            if (containerRef.current) {
                setHeight(containerRef.current.getBoundingClientRect().height);
            }
            }, 1000);
        }

        window.addEventListener('resize', updateHeight);
        window.addEventListener("scroll", update);
        loop(); // start animation loop

        return () => {
        window.removeEventListener("scroll", update);
        window.removeEventListener('resize', updateHeight);
        // observer?.disconnect();
        };
        

    }, [isDesktop,y]);


//      useEffect(() => {
//     const updateScroll = () => {
//       scrollRef.current = window.scrollY;
//     };

//     const loop = () => {
//       animate(y, -scrollRef.current, {
//         type: "spring",
//         damping: 35,
//         stiffness: 120,
//         mass: 0.4,
//       });
//       requestAnimationFrame(loop);
//     };

//     const updateHeight = () => {
//       if (containerRef.current) {
//         const scrollHeight = containerRef.current.getBoundingClientRect().height;
//         setHeight(scrollHeight);
//       }
//     };

//     // Initial height update
//     updateHeight();

//     // ResizeObserver to watch layout shifts
//     const resizeObserver = new ResizeObserver(() => {
//       updateHeight();
//     });

//     if (containerRef.current) {
//       resizeObserver.observe(containerRef.current);
//     }

//     // Resize and scroll handlers
//     window.addEventListener("resize", updateHeight);
//     window.addEventListener("scroll", updateScroll);

//     // Fallback timeout to fix any late reflows (especially on mobile)
//     setTimeout(updateHeight, 1000);
//     setTimeout(updateHeight, 2000);

//     loop();

//     return () => {
//       resizeObserver.disconnect();
//       window.removeEventListener("resize", updateHeight);
//       window.removeEventListener("scroll", updateScroll);
//     };
//   }, [y]);

   

    useEffect(() => {
        const updateMenuState = () => {
            const ismenuOpen = localStorage.getItem("ismenuOpen") === 'true';
            setOpen(ismenuOpen);
        };

        // Initial load
        updateMenuState();

        // Listen to custom event
        window.addEventListener("sidemenuToggle", updateMenuState);

        return () => {
            window.removeEventListener("sidemenuToggle", updateMenuState);
        };
    }, []);


    return (
            <>
            {isDesktop && <div style={{ height:`${height}px`}}></div>}
            {isDesktop ?
                (<All.MotionDiv id="scrollsmoother-container" 
                    ref={containerRef}                                
                    initial={{ opacity: 1, scale: 1, visibility: "visible" }}
                    animate={open 
                        ? { opacity: 0.1, scale: 0.97 }  // Animation when opening menu
                        : { opacity: 1, scale: 1 }  // Animation when closing menu
                    }
                    transition={open 
                        ? { duration: 1, delay:0, ease: 'easeOut' } // Transition when opening menu
                        : { duration: 1, delay:1.7, ease: 'easeOut' } // Transition when closing menu \
                        }>
                            {children} 
                </All.MotionDiv>)
                :
                (<All.MotionDiv id="scrollsmoother-container"                          
                    initial={{ opacity: 1, scale: 1, visibility: "visible" }}
                    animate={open 
                        ? { opacity: 0.1, scale: 0.97 }  // Animation when opening menu
                        : { opacity: 1, scale: 1 }  // Animation when closing menu
                    }
                    transition={open 
                        ? { duration: 1, delay:0, ease: 'easeOut' } // Transition when opening menu
                        : { duration: 1, delay:1.7, ease: 'easeOut' } // Transition when closing menu \
                        }>
                            {children} 
                </All.MotionDiv> )}          
            </>
    );
}